// Fixed loss vertex schema
// Simple passive device. Dual elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';

export const FixedLossVertexSchema = BaseVertexSchema.extend({
  type: z.literal('fixed_loss'),
  // C++ emits these only when is_set() (per as_json audit § 4).
  inlet_elevation: ValueWithUnitSchema.optional(),
  outlet_elevation: ValueWithUnitSchema.optional(),
  /** Fixed pressure drop (K factor or dP) */
  loss: ValueWithUnitSchema.optional(),
});

export type FixedLossVertex = z.infer<typeof FixedLossVertexSchema>;
